import { RootState } from 'context'
import { setAmount } from 'context/reducer/quota'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'interfaces/app'
import { debounceTime, filter, tap, map } from 'rxjs/operators'
import { Subject } from 'rxjs'
import { DEBOUNCE_TIMER } from 'constants/index'
const input$ = new Subject()

export const InputAmount: React.FC = () => {
  const { isMobile } = useSelector<RootState, AppState>((state) => state.app)
  const dispatch = useDispatch()
  const [amountValue, setAmountValue] = useState('')

  useEffect(() => {
    const subscription = input$.pipe(
        filter((value: any) => (+value.trim()).toString() !== 'NaN'),
        map((value: any) => value.replace('.', '')),
        map((value: any) => value.replace(' ', '')),
        tap((value: any) => {
          setAmountValue(
            value === 'NaN' || value === ''
              ? ''
              : parseInt(value,10).toLocaleString('de-DE')
          )
        }),
        debounceTime(DEBOUNCE_TIMER),
        map((value: any) => (value === '0' || value === 'NaN' ? '' : value)),
        map((value: any) => (parseInt(value,10) < 300 ? '300' : value)),
        map((value: any) => (parseInt(value,10) > 40000 ? '40000' : value))
      )
      .subscribe((value) => {
        dispatch(setAmount(value))
        setAmountValue(
          value === 'NaN' || value === ''
            ? ''
            : parseInt(value.replace('.', ''),10).toLocaleString('de-DE')
        )
      })
    return () => subscription.unsubscribe()
  }, [dispatch])

  const handleChangeAmount = (event: any) => {
    input$.next(event.target.value)
  }

  return (
    <div className={`text-center ${isMobile ? 'bp-p-16' : 'bp-mt-16'}`}>
      <pichincha-typography
        align="center"
        variant="bodyText"
        color="darkGrey"
        weight_color="700"
      >
        Escribe un valor entre mínimo $300 y máximo $40.000.
      </pichincha-typography>
      <div className='bp-mt-16'>
        <label className="lineAmount" >
          <label  style={{color:amountValue?'#0f265c':'#9FA8BE'}}>$</label>
          <input
            id="input-amount"
            className="inputAmount"
            type="tel"
            placeholder='12.000'
            autoComplete='off'
            value={amountValue}
            onChange={handleChangeAmount}
          />
        </label>
      </div>

    </div>
  )
}
